import api from 'api';

const url = id => `/api/reservations/${id}`;

export default {
    void: id => api.delete({path: url(id)})
}